// src/layouts/AdminTopBar.jsx
import React from "react";
import { Box, IconButton, Divider } from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import { useAdminNav } from "./AdminNavContext";

export default function AdminTopBar() {
  const { openNav } = useAdminNav();
  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: (t) => t.zIndex.appBar,
        bgcolor: "background.paper",
        display: "flex",
        alignItems: "center",
        height: 48,
        px: 1,
      }}>
      <IconButton aria-label="Open menu" onClick={openNav} size="small">
        <MenuIcon />
      </IconButton>
      <Divider sx={{ position: "absolute", left: 0, right: 0, bottom: 0 }} />
    </Box>
  );
}
